import { render, staticRenderFns } from "./ProofOfDeliveryTemplate.vue?vue&type=template&id=3e2f33c4&scoped=true&"
import script from "./ProofOfDeliveryTemplate.vue?vue&type=script&lang=js&"
export * from "./ProofOfDeliveryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDeliveryTemplate.vue?vue&type=style&index=0&id=3e2f33c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f33c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2f33c4')) {
      api.createRecord('3e2f33c4', component.options)
    } else {
      api.reload('3e2f33c4', component.options)
    }
    module.hot.accept("./ProofOfDeliveryTemplate.vue?vue&type=template&id=3e2f33c4&scoped=true&", function () {
      api.rerender('3e2f33c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ProofOfDelivery/ProofOfDeliveryTemplate.vue"
export default component.exports